import { useField } from "formik";

import "../Forms.scss";

/**
 * TextInput component
 * @param {{
 *   name: string,
 *   value?: string,
 *   label?: string,
 *   type?: "search"|"email"|"text|"number",
 *   placeholder?: string,
 *   disabled?: boolean,
 *   bottomText?: string,
 *   className?: string,
 *   onChange?: (value: string) => void,
 *   autoFocus?: boolean,
 *   prefix?: string
 *   isDataList?: boolean,
 *   dataListItems?: {label: string, value: string}[]
 * }} props
 * @returns {JSX.Element} TextInput
 */
function TextInput({
  name,
  value,
  label,
  type = "text",
  placeholder,
  disabled,
  bottomText,
  className,
  onChange,
  autoFocus,
  prefix,
  isDataListed = false,
  dataListItems = [],
}) {
  const [field, meta] = useField(name);

  function handleChange(e) {
    if (onChange) {
      onChange(e.target.value);
    } else {
      field.onChange(e);
    }
  }

  return (
    <div
      className={`input ${className} ${
        meta.touched && meta.error ? "error" : ""
      }`}
    >
      {label ? <label htmlFor={name}>{label}</label> : null}

      <div className="input-field">
        {prefix ? <span className="prefix">{prefix}</span> : null}
        <input
          {...field}
          value={value || field.value}
          list={isDataListed ? `${name}-list` : null}
          type={type}
          name={name}
          id={name}
          placeholder={placeholder}
          disabled={disabled}
          onChange={handleChange}
          autoFocus={autoFocus}
        />
        {isDataListed ? (
          <datalist id={`${name}-list`}>
            {dataListItems.map((item) => (
              <option key={item} value={item} />
            ))}
          </datalist>
        ) : null}
      </div>

      <div className="meta">
        {meta.touched && meta.error ? (
          <small className="error-msg">{meta.error}</small>
        ) : null}
        {bottomText ? <small>{bottomText}</small> : null}
      </div>
    </div>
  );
}

export default TextInput;
